import React, { Fragment } from "react";
import {
  Table,
  Icon,
  Button,
  Popover,
  Modal,
  Dropdown,
  Menu,
  Spin,
  Checkbox,
} from "antd";
import { withRouter } from "react-router-dom";
import memoize from "memoize-one";
import { injectIntl, FormattedMessage } from "react-intl";
import { LoadingSpinner } from "../LoadingSpinner";
import AddPeopleToGroupModal from "../../AddPeopleToGroupModal";
import styles from "./styles.module.scss";
import "./styles.scss";
import { connect } from "react-redux";
import { PersonFormDrawer } from "../PersonFormDrawer";
import countries from "../../../utils/countryCodes";
import { setCookie, getCookie } from "../../../utils/helpers";
import _ from "lodash";
import cw from "../../../utils/commonwords";
import { ViewPersonDrawer } from "../ViewPersonDrawer";
import classNames from "classnames";
import DeleteIcon from "../../../images/delete.svg";
import MoreIcon from "../../../images/more.svg";
import EditIcon from "../../../images/edit.svg";
import PersonAvatar from "../../../images/person-avatar.svg";
import UserAvatar from "../../../images/user-avatar.svg";

import {
  removePersonFromGroup,
  addPeopleToGroup,
  fetchGroupPeople,
} from "../../../store/groups/actions";

import {
  fetchPerson,
  uploadPeopleFromFile,
  addPerson,
  uploadPeopleFromFileConfirm,
  deletePerson,
  editPerson,
} from "../../../store/people/actions";
// import { ReactComponent as EditTableIcon } from '../../../images/edit-table.svg';
import NoPeople from "../../NoPeople/NoPeople";
import { API_URL } from "../../../config/environment";
import TableLayout from "./TableLayout";

class PeopleTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
    this.state = {
      selectedRowKeys: [],
      addToGroupModalVisible: false,
      editToGroupModalVisible: false,
      filteredGroups: [],
      sortedColumns: getCookie("sortedColumns")
        ? JSON.parse(getCookie("sortedColumns"))
        : ["Photo", "Name", "Phone Number", "Email", "Occupation", "Id Number"],
      sortingColumns: [
        { title: "Name" },
        { title: "Phone Number" },
        { title: "Email" },
        { title: "Occupation" },
        { title: "Id Number" },
        { title: "Gender" },
        { title: "Title" },
        { title: "Country" },
        { title: "City" },
        { title: "Date of Birth" },
        { title: "GPS Location" },
      ],
      showViewPersonDrawer: false,
      personToViewId: "",
      hideColumns: false,
      addPersonDrawerVisible: false,
      deletePersonModalVisible: false,
    };
  }

  static defaultProps = {
    sc: [],
    personAdded: false,
    loading: false,
    people: null,
    tableFor: "everyone",
    groups: [],
    person: {},
  };
  componentWillReceiveProps = (newProps) => {
    const { groups } = this.props;
    this.setState((state, props) => ({
      filteredGroups: groups,
    }));
  };
  imgError = (ev) => {
    ev.onerror = "";
    ev.target.src = `${UserAvatar}`;
    return true;
  };

  addPeopleToGroup = (groupId, personId) => {
    const { addPeopleToGroup, userId, intl, siteLanguage } = this.props;
    addPeopleToGroup(groupId, personId, userId, intl, siteLanguage, () => {
      this.setState({ selectedRowKeys: [] });
    });
  };

  handleEditPersonBtnClick = (e, record) => {
    const { userId, intl, siteLanguage, fetchPerson } = this.props;
    this.setState(
      (state, props) => ({
        editToGroupModalVisible: true,
      }),
      () => {
        fetchPerson(record.key, userId, intl, siteLanguage);
      }
    );
  };
  handleViewPersonBtnClick = (e, record) => {
    const { fetchPerson, userId, intl, siteLanguage } = this.props;

    this.setState(
      (state, props) => ({
        showViewPersonDrawer: true,
      }),
      () => {
        fetchPerson(record.key, userId, intl, siteLanguage);
      }
    );
  };
  handleCloseViewPersonDrawer = () => {
    this.setState((state, props) => ({
      showViewPersonDrawer: false,
    }));
  };

  handleEditPersonDrawerClose = () => {
    this.setState((state, props) => ({
      editToGroupModalVisible: false,
    }));
  };
  editPersonDrawerFormRef = (editPersonFormRef) => {
    this.editPersonFormRef = editPersonFormRef;
  };
  newPersonDrawerFormRef = (newPersonFormRef) => {
    this.newPersonFormRef = newPersonFormRef;
  };

  handlePersonAdd = () => {
    const form = this.newPersonFormRef.props.form;
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      console.log(values);
      this.handleAddPerson(values);
    });
  };

  handleAddPerson = (values) => {
    const { addPerson, userId, intl, siteLanguage } = this.props;

    const { peopleLimit, peoplePage } = this.state;

    const { customDataKeys, CustomData, groups, ...personDataMessy } = values;
    let personData = _.pickBy(personDataMessy, _.identity);

    if (personData["Date of Birth"]) {
      personData["Date of Birth"] =
        personData["Date of Birth"].format("YYYY-MM-DD");
    }
    let Custom = {};
    if (CustomData) {
      CustomData.forEach((dt) => {
        Custom[dt.fieldName] = dt.fieldValue;
      });
    }
    personData["Custom"] = Custom;
    const data = {
      personData: personData,
      personMeta: { source: "dfs people", groups: groups ? [groups] : "" },
      userId,
    };
    addPerson(data, peopleLimit, peoplePage, userId, intl, siteLanguage);
  };

  handlePersonEdit = (e, Photo) => {
    const form = this.editPersonFormRef.props.form;
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      // console.log(values);
      this.handleEditPerson(values);
    });
  };

  handleEditPerson = (values) => {
    const {
      editPerson,
      userId,
      intl,
      siteLanguage,
      person: { uuid },
      peopleLimit,
      peoplePage,
      fetchedGroupId,
    } = this.props;

    const { customDataKeys, CustomData, groups, ...personDataMessy } = values;
    let personData = _.pickBy(personDataMessy, _.identity);

    if (personData["Date of Birth"]) {
      personData["Date of Birth"] =
        personData["Date of Birth"].format("YYYY-MM-DD");
    }
    let Custom = {};
    if (CustomData) {
      CustomData.forEach((dt) => {
        Custom[dt.fieldName] = dt.fieldValue;
      });
    }
    personData["Custom"] = Custom;
    const editData = {
      personData: personData,
      personMeta: { source: "dfs people" },
      userId,
    };

    editPerson(
      editData,
      uuid,
      peopleLimit,
      peoplePage,
      userId,
      intl,
      siteLanguage,
      fetchedGroupId
    );
  };

  showAddToGroupModal = () => {
    this.setState({ addToGroupModalVisible: true });
  };

  handleCancelAddPeopleToGroup = (e, s) => {
    this.setState({ addToGroupModalVisible: false });
  };

  toggleSortingColumnsChecked = (e) => {
    const { sortedColumns } = this.state;
    const { name } = e.target;

    if (sortedColumns.includes(name)) {
      const sortedC = sortedColumns.filter((value, index, arr) => {
        return value !== name;
      });
      setCookie("sortedColumns", JSON.stringify(sortedC));
      this.setState({
        sortedColumns: sortedC,
      });
    } else {
      setCookie("sortedColumns", JSON.stringify([...sortedColumns, name]));
      this.setState({
        sortedColumns: [...sortedColumns, name],
      });
    }
  };

  handleGroupSearch = (e) => {
    const val = e.target.value;
    const { groups } = this.props;
    this.setState((state, props) => ({
      filteredGroups: groups.filter(
        (el) => el.name.toLowerCase().indexOf(val.toLowerCase()) > -1
      ),
    }));
  };

  addToGroupFormRef = (formRef) => {
    this.formRef = formRef;
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({
      selectedRowKeys,
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    const {
      fetchPeople,
      peopleLimit,
      userId,
      intl,
      siteLanguage,
      fetchGroupPeople,
      location,
      groupPeopleLimit,
      fetchedGroupId,
    } = this.props;

    this.scrollRef.current.scrollIntoView({
      bahavior: "smooth",
      block: "center",
    });

    if (location.pathname.includes("/groups/")) {
      fetchGroupPeople(
        fetchedGroupId,
        userId,
        intl,
        siteLanguage,
        groupPeopleLimit,
        pagination.current
      );
    } else {
      fetchPeople(userId, peopleLimit, pagination.current, intl, siteLanguage);
    }
  };

  addPeopleToGroupVisibility = (personAdded, addToGroupModalVisible) => {
    if (personAdded) {
      this.setState((state, props) => ({
        addToGroupModalVisible: false,
      }));
      return false;
    } else {
      return addToGroupModalVisible;
    }
  };

  editPersonVisibility = (personEdited, editToGroupModalVisible) => {
    if (personEdited) {
      const comp = this.editPersonFormRef;
      comp.setState({ imageUrl: "" });

      this.setState((state, props) => ({
        editToGroupModalVisible: false,
      }));
      return false;
    } else {
      return editToGroupModalVisible;
    }
  };

  addPersonDrawerVisiblility = (personAdded, addPersonDrawerVisible) => {
    if (personAdded) {
      const comp = this.newPersonFormRef;
      comp.onCancel();
      return false;
    } else {
      return addPersonDrawerVisible;
    }
  };

  deletePersonModalVisibility = (personDeleted, deletePersonModalVisible) => {
    if (personDeleted) {
      // const comp = this.editPersonFormRef;
      // comp.setState({ imageUrl: '' });

      this.setState((state, props) => ({
        deletePersonModalVisible: false,
        selectedRowKeys: [],
      }));
      return false;
    } else {
      return deletePersonModalVisible;
    }
  };

  memoizedAddPersonDrawerVisiblility = memoize(this.addPersonDrawerVisiblility);
  memoizedAddPeopleToGroupVisibility = memoize(this.addPeopleToGroupVisibility);
  memoizedEditPersonToGroupVisibility = memoize(this.editPersonVisibility);
  memoizedDeletePersonModalVisibility = memoize(
    this.deletePersonModalVisibility
  );

  handleAddPersonDrawerClose = () => {
    this.setState((state, props) => ({
      addPersonDrawerVisible: false,
    }));
  };

  handleAddPersonBtnClick = () => {
    this.setState((state, props) => ({
      addPersonDrawerVisible: true,
    }));
  };

  handleCancelSelectionClick = () => {
    this.setState((state, props) => ({
      selectedRowKeys: [],
    }));
  };

  removePersonFromGroup = (personId) => {
    const {
      intl,
      userId,
      siteLanguage,
      fetchedGroupId,
      removePersonFromGroup,
    } = this.props;

    Modal.confirm({
      centered: true,
      title: intl.formatMessage(cw["RemovePerson"]),
      content: intl.formatMessage(cw["DeleteGroupPersonConfirm"]),
      okText: intl.formatMessage(cw["Button.Remove"]),
      onOk() {
        removePersonFromGroup(
          personId,
          fetchedGroupId,
          userId,
          intl,
          siteLanguage
        );
      },
    });
  };

  handleMoreButtonClick = (e, person) => {
    if (e.key === "add-to-another-group") {
      this.setState({ selectedRowKeys: [person.key] }, () => {
        this.showAddToGroupModal();
      });
    } else if (e.key === "remove-from-group") {
      this.removePersonFromGroup(person.key);
    }
  };
  handleAddPeopleToGroup = (gid) => {
    const { selectedRowKeys } = this.state;
    this.addPeopleToGroup(gid, selectedRowKeys);
  };
  handlePersonDelete = (e, ids) => {
    const {
      deletePerson,
      deletingPerson,
      userId,
      intl,
      siteLanguage,
      peoplePage,
      peopleLimit,
      fetchedGroupId,
    } = this.props;
    Modal.confirm({
      centered: true,
      title: `${intl.formatMessage(cw["Delete"])} ${
        [].concat(ids).length === 1
          ? intl.formatMessage(cw["person"])
          : intl.formatMessage(cw["people"])
      }`,
      content: intl.formatMessage(cw["DeletePersonInfo"], {
        person: [].concat(ids).length === 1 ? "this person" : "these people",
      }),
      okText: intl.formatMessage(cw["Delete"]),
      cancelText: intl.formatMessage(cw["No"]),
      onOk() {
        deletePerson(
          [].concat(ids),
          peopleLimit,
          peoplePage,
          userId,
          intl,
          siteLanguage,
          fetchedGroupId
        );
      },
      okButtonProps: { loading: deletingPerson },
    });
  };
  uploadPeopleFromFile = (values) => {
    const {
      uploadPeopleFromFile,
      userId,
      intl,
      siteLanguage,
      peopleLimit,
      peoplePage,
    } = this.props;
    uploadPeopleFromFile(
      values,
      peopleLimit,
      peoplePage,
      userId,
      intl,
      siteLanguage
    );
  };
  uploadPeopleFromFileConfirm = (data) => {
    const {
      uploadPeopleFromFileConfirm,
      userId,
      intl,
      siteLanguage,
      peopleLimit,
      peoplePage,
    } = this.props;
    uploadPeopleFromFileConfirm(
      data,
      peopleLimit,
      peoplePage,
      userId,
      intl,
      siteLanguage
    );
  };

  render() {
    const {
      people,
      tableFor,
      addingPeopleToGroup,
      personAdded,
      personAddedToGroup,
      screen,
      editingPerson,
      groups,
      person,
      fetchingPerson,
      personEdited,
      userId,
      siteLanguage,
      fetchPerson,
      fetchingPeople,
      fetchedGroupId,
      addingPerson,
      intl,
      peopleUploaded,
      uplodPeopleError,
      uploadedPeople,
      fileName,
      peoplePage,
      numberOfPeople,
      query,
      totalNumberOfPeople,
      loading,
      location,
      personDeleted,
      groupPeoplePage,
      groupType,
      parentGroupId,
      totalNumberOfGroupPeople,
    } = this.props;

    const page = tableFor === "everyone" ? peoplePage : groupPeoplePage;

    const {
      sortedColumns,
      filteredGroups,
      sortingColumns,
      selectedRowKeys,
      showViewPersonDrawer,
      addToGroupModalVisible,
      editToGroupModalVisible,
      hideColumns,
      addPersonDrawerVisible,
      uploadingPeopleFromFile,
      deletePersonModalVisible,
    } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      hideDefaultSelections: true,
      fixed: true,
    };
    const hasSelected = selectedRowKeys.length > 0;

    const showToGroupModal = this.memoizedAddPeopleToGroupVisibility(
      personAddedToGroup,
      addToGroupModalVisible
    );
    const showEditPersonGroupModal = this.memoizedEditPersonToGroupVisibility(
      personEdited,
      editToGroupModalVisible
    );
    const showNewPersonDrawer = this.memoizedAddPersonDrawerVisiblility(
      personAdded,
      addPersonDrawerVisible
    );

    this.memoizedDeletePersonModalVisibility(
      personDeleted,
      deletePersonModalVisible
    );

    const canEditPerson = !(
      location.pathname.includes("/groups/") &&
      (groupType === "system" || parentGroupId)
    );

    return (
      <div>
        <div className="people-table" style={{ marginTop: "9.5rem" }}>
          {hasSelected && (
            <div className={styles.toolbar}>
              <div>
                <Button type="link" onClick={this.showAddToGroupModal}>
                  {/* <Icon type="plus" /> Add to {tableFor === 'group' ? 'another' : 'a'} group */}
                  {tableFor === "group" ? (
                    <FormattedMessage
                      id="AddToAnotherGroup"
                      defaultMessage="Add to another group"
                    />
                  ) : (
                    <FormattedMessage
                      id="AddToGroup"
                      defaultMessage="Add to a group"
                    />
                  )}
                </Button>
                {canEditPerson && (
                  <Button
                    type="link"
                    onClick={(e) =>
                      this.handlePersonDelete(e, this.state.selectedRowKeys)
                    }
                  >
                    <Icon type="delete" theme="filled" />
                    <FormattedMessage
                      id="App.Delete"
                      defaultMessage={"Delete"}
                    />
                    <small>
                      &nbsp; ({selectedRowKeys.length}{" "}
                      <FormattedMessage
                        id="selected"
                        defaultMessage="selected"
                      />
                      &nbsp;
                      {selectedRowKeys.length === 1 ? (
                        <FormattedMessage
                          id="App.Person"
                          defaultMessage={"person"}
                        />
                      ) : (
                        <FormattedMessage
                          id="App.People"
                          defaultMessage={"people"}
                        />
                      )}
                    </small>
                    )
                  </Button>
                )}
              </div>
            </div>
          )}
          {query && !loading && !hasSelected && (
            <div className={styles.searchResults}>
              {[].concat(people).length <= 0 ? (
                <React.Fragment>
                  <FormattedMessage
                    id="NoResultsFoundEveryone"
                    defaultMessage="No results found for"
                  />{" "}
                  "{query}"
                </React.Fragment>
              ) : (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h3>
                    <FormattedMessage
                      id="SearchResultsFor"
                      defaultMessage="Search results for"
                    />{" "}
                    "{query}"
                  </h3>
                  <span style={{ marginLeft: "5px" }}>
                    {parseInt(numberOfPeople) !== 0 && (
                      <small>
                        <span data-dfs-people-id="number-of-people">
                          {parseInt(
                            tableFor === "group"
                              ? totalNumberOfGroupPeople
                              : numberOfPeople
                          ).toLocaleString()}
                        </span>{" "}
                        <FormattedMessage
                          id="RecordsFound"
                          defaultMessage="record(s) found"
                        />
                      </small>
                    )}
                  </span>
                </div>
              )}
            </div>
          )}

          {people.length > 0 && (
            <React.Fragment>
              <span ref={this.scrollRef}></span>
              <TableLayout
                canEditPerson={canEditPerson}
                handleViewPersonBtnClick={this.handleViewPersonBtnClick}
                hideColumns={hideColumns}
                rowSelection={rowSelection}
                loading={loading}
                handleTableChange={this.handleTableChange}
                people={people}
                page={page}
                totalNumberOfPeople={totalNumberOfPeople}
                handlePersonDelete={this.handlePersonDelete}
                handleMoreButtonClick={this.handleMoreButtonClick}
                handleEditPersonBtnClick={this.handleEditPersonBtnClick}
                tableFor={tableFor}
                toggleSortingColumnsChecked={this.toggleSortingColumnsChecked}
                sortingColumns={sortingColumns}
                sortedColumns={sortedColumns}
                imgError={this.imgError}
              />
            </React.Fragment>
          )}
          {!fetchingPeople && !query && people.length < 1 && (
            <div style={{ marginTop: "26vh" }}>
              <NoPeople
                uploadPeopleFromFile={this.uploadPeopleFromFile}
                handleAddPersonBtnClick={this.handleAddPersonBtnClick}
                uploadingPeopleFromFile={uploadingPeopleFromFile}
                peopleUploaded={peopleUploaded}
                uplodPeopleError={uplodPeopleError}
                uploadedPeople={uploadedPeople}
                uploadPeopleFromFileConfirm={this.uploadPeopleFromFileConfirm}
                fileName={fileName}
                userId={userId}
                fetchedGroupId={fetchedGroupId}
              />
            </div>
          )}
          {fetchingPeople && people.length < 1 && (
            <div
              style={{
                textAlign: "center",
                position: "absolute",
                top: "40%",
                left: "50%",
              }}
            >
              <Spin indicator={LoadingSpinner} />
            </div>
          )}
          <AddPeopleToGroupModal
            wrappedComponentRef={this.addToGroupFormRef}
            visible={showToGroupModal}
            onCancel={this.handleCancelAddPeopleToGroup}
            onCreate={this.handleAddPeopleToGroup}
            groups={filteredGroups}
            onGroupSearch={this.handleGroupSearch}
            addingPeopleToGroup={addingPeopleToGroup}
            personAdded={personAdded}
            intl={intl}
          />
          <PersonFormDrawer
            location={location}
            intl={intl}
            data={person["data"]}
            person={person}
            personEdited={personEdited}
            drawerTitle="Edit person"
            wrappedComponentRef={this.editPersonDrawerFormRef}
            width={
              screen !== "screen-xxl"
                ? screen === "screen-md"
                  ? "50%"
                  : screen === "screen-sm" || screen === "screen-xs"
                  ? "80%"
                  : "35%"
                : "25%"
            }
            onOk={this.handlePersonEdit}
            onCancel={this.handleEditPersonDrawerClose}
            visible={showEditPersonGroupModal}
            okButtonProps={{
              loading: editingPerson,
              "data-dfs-people-id": "person-edit-form-drawer-edit-button",
            }}
            countries={countries}
            myGroups={groups}
            fetchingPerson={fetchingPerson}
            mode="edit"
            fetchPerson={fetchPerson}
          />
          <PersonFormDrawer
            location={location}
            intl={intl}
            drawerTitle={this.props.intl.formatMessage(cw["NewPerson"])}
            personAdded={personAdded}
            wrappedComponentRef={this.newPersonDrawerFormRef}
            width={
              screen !== "screen-xxl"
                ? screen === "screen-md"
                  ? "50%"
                  : screen === "screen-sm" || screen === "screen-xs"
                  ? "80%"
                  : "35%"
                : "25%"
            }
            onOk={this.handlePersonAdd}
            onCancel={this.handleAddPersonDrawerClose}
            visible={showNewPersonDrawer}
            okButtonProps={{
              loading: addingPerson,
              "data-dfs-people-id": "person-add-form-drawer-add-button",
            }}
            countries={countries}
            myGroups={groups}
            mode="create"
            fetchedGroupId={fetchedGroupId}
            fetchingPerson={fetchingPerson}
          />
          <ViewPersonDrawer
            editable={canEditPerson}
            data={person["data"]}
            person={person}
            handleEdit={(e, record) => {
              this.handleCloseViewPersonDrawer();
              this.handleEditPersonBtnClick(e, record);
            }}
            handleDelete={(e, record) => {
              this.handleCloseViewPersonDrawer();
              this.handlePersonDelete(e, [record["key"]]);
            }}
            userId={userId}
            siteLanguage={siteLanguage}
            wrappedComponentRef={this.viewPersonDrawerRef}
            width={
              screen !== "screen-xxl"
                ? screen === "screen-md"
                  ? "50%"
                  : screen === "screen-sm" || screen === "screen-xs"
                  ? "80%"
                  : "35%"
                : "25%"
            }
            fetchPerson={fetchPerson}
            personToViewId={person.uuid}
            onCancel={this.handleCloseViewPersonDrawer}
            visible={showViewPersonDrawer}
            okButtonProps={{
              loading: editingPerson,
              "data-dfs-people-id": "person-edit-form-drawer-edit-button",
            }}
            fetchingPerson={fetchingPerson}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  siteLanguage: state.intl.siteLanguage,
  userId: state.user.userId,
  fetchedGroupId: state.groups.fetchedGroupId,
  parentGroupId: state.groups.parentGroupId,
  groupType: state.groups.groupType,
  removingPersonFromGroup: state.groups.removingPersonFromGroup,
  personRemovedFromGroup: state.groups.personRemovedFromGroup,
  addingPerson: state.people.addingPerson,
  personAdded: state.people.personAdded,
  personAddedToGroup: state.groups.personAddedToGroup,
  addingPeopleToGroup: state.groups.addingPeopleToGroup,
  uploadedPeople: state.people.uploadedPeople,
  uplodPeopleError: state.people.uplodPeopleError,
  peopleUploaded: state.people.peopleUploaded,
  fileName: state.people.fileName,
  deletingPerson: state.people.deletingPerson,
  personDeleted: state.people.personDeleted,
  personEdited: state.people.personEdited,
  editingPerson: state.people.editingPerson,
  numberOfPeople: state.people.numberOfPeople,
  loading:
    state.people.fetchingPeople ||
    state.groups.fetchingGroupPeople ||
    state.people.deletingPerson,
  numberOfGroupPeople: state.groups.numberOfGroupPeople,
  totalNumberOfGroupPeople: state.groups.totalNumberOfGroupPeople,
  groupPeopleLimit: state.groups.groupPeopleLimit,
  groupPeoplePage: state.groups.groupPeoplePage,
});

const mapDispatchToProps = (dispatch) => ({
  removePersonFromGroup: (personId, groupId, userId, intl, siteLanguage) => {
    dispatch(
      removePersonFromGroup(personId, groupId, userId, intl, siteLanguage)
    );
  },
  fetchPerson: (personId, userId, intl, siteLanguage) => {
    dispatch(fetchPerson(personId, userId, intl, siteLanguage));
  },
  uploadPeopleFromFile: (data, limit, page, userId, intl, siteLanguage) => {
    dispatch(
      uploadPeopleFromFile(data, limit, page, userId, intl, siteLanguage)
    );
  },
  addPerson: (data, limit, page, userId, intl, siteLanguage) => {
    dispatch(addPerson(data, limit, page, userId, intl, siteLanguage));
  },
  addPeopleToGroup: (groupId, personId, userId, intl, siteLanguage, onOK) => {
    dispatch(
      addPeopleToGroup(groupId, personId, userId, intl, siteLanguage, onOK)
    );
  },
  uploadPeopleFromFileConfirm: (
    data,
    limit,
    page,
    userId,
    intl,
    siteLanguage
  ) => {
    dispatch(
      uploadPeopleFromFileConfirm(data, limit, page, userId, intl, siteLanguage)
    );
  },
  deletePerson: (
    personId,
    limit,
    page,
    userId,
    intl,
    siteLanguage,
    groupId
  ) => {
    dispatch(
      deletePerson(personId, limit, page, userId, intl, siteLanguage, groupId)
    );
  },
  editPerson: (
    data,
    uuid,
    limit,
    page,
    userId,
    intl,
    siteLanguage,
    groupId
  ) => {
    dispatch(
      editPerson(data, uuid, limit, page, userId, intl, siteLanguage, groupId)
    );
  },
  fetchGroupPeople: (groupsId, userId, intl, siteLanguage, limit, page) => {
    dispatch(
      fetchGroupPeople(groupsId, userId, intl, siteLanguage, limit, page)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(withRouter(PeopleTable)));
